

// import React, { useState } from 'react'
// import JobApplicationButton from "../../pages/Profile/JobApplicationButton";
// import FormAnalytics from "../../Admin/JobApplicationFormAnalytics";
// import JobApplicationFormShareable from "../../Admin/JobApplicationFormSharable";

// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import axios from "axios";
// import html2pdf from "html2pdf.js";
// import { FaTimes } from "react-icons/fa";

// const ApplicationForm = () => {
//   const [showForm, setShowForm] = useState(false);

//   // Carousel settings
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     arrows: true,
//     responsive: [
//       {
//         breakpoint: 1024, // lg
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 640, // sm
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           dots: true,
//           arrows: false, // Hide arrows on mobile for cleaner look
//           speed: 300, // Faster transition for mobile
//           centerMode: true, // Center the slide on mobile
//           centerPadding: '20px', // Add padding around centered slide
//         },
//       },
//     ],
//   };

//   return (
//     <div className="my-10 relative w-screen vw-full  sm:py-12 bg-gray-50 sm:bg-gray-50">
//       <div className="w-full p-6 sm:p-10 rounded-lg bg-blue-50 sm:bg-blue-50 max-w-5xl mx-auto shadow-lg sm:shadow-none">
//         {/* Descriptive Section for Job Seekers */}
//         <div className="text-center mb-8 sm:mb-12">
//           <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
//             Job Application Form for Job Seekers
//           </h2>
//           <p className="text-base sm:text-lg text-gray-600 max-w-xl sm:max-w-2xl mx-auto leading-relaxed">
//             Kickstart your career with our comprehensive job application form. Fill out the form, download
//             it as a PDF, and share it with potential employers via email or WhatsApp. This form is designed
//             to help you present your qualifications, experience, and skills professionally.
//           </p>
//           <p className="text-xs sm:text-sm text-gray-500 mt-2 italic">
//             Complete the form accurately and download it to submit to your desired job opportunities.
//           </p>
//         </div>

//         {/* Carousel for Application Components */}
//         {/* <Slider {...settings}> */}
//           <div className="px-2">
//             <JobApplicationButton onClick={() => setShowForm(true)} />
//           </div>
//           <div className="px-2">
//             <FormAnalytics />
//           </div>
//         {/* </Slider> */}

//         {/* Modal for Job Application Form */}
//         {showForm && <JobApplicationFormShareable onClose={() => setShowForm(false)} />}
//       </div>
//     </div>
//   );
// };

// export default ApplicationForm;













import React, { useState } from 'react'
import JobApplicationButton from "../../pages/Profile/JobApplicationButton";
import FormAnalytics from "../../Admin/JobApplicationFormAnalytics";
import JobApplicationFormShareable from "../../Admin/JobApplicationFormSharable";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import html2pdf from "html2pdf.js";
import { FaTimes } from "react-icons/fa";

const ApplicationForm = () => {
  const [showForm, setShowForm] = useState(false);

  // Carousel settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // lg
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640, // sm
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false, // Hide arrows on mobile for cleaner look
          speed: 300, // Faster transition for mobile
          centerMode: true, // Center the slide on mobile
          centerPadding: '20px', // Add padding around centered slide
        },
      },
    ],
  };

  return (
    <div className="my-10 relative w-screen vw-full py-12 bg-gray-50 sm:bg-gray-50 lg:bg-gradient-to-r lg:from-blue-100 lg:via-blue-50 lg:to-blue-100">
     <h2 className="text-2xl text-center sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 lg:mb-6">
            Job Application Form for Job Seekers
          </h2>
      <div className="w-full px-4 sm:px-10 lg:px-0 max-w-7xl mx-auto flex flex-col lg:flex-row lg:items-center lg:justify-between">
        {/* Descriptive Section for Job Seekers */}
         
        <div className="text-center mb-8 sm:mb-12 lg:text-left lg:w-1/2 lg:pr-8">
        
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-xl sm:max-w-2xl lg:max-w-md mx-auto lg:mx-0 leading-relaxed">
            Kickstart your career with our comprehensive job application form. Fill out the form, download
            it as a PDF, and share it with potential employers via email or WhatsApp. This form is designed
            to help you present your qualifications, experience, and skills professionally.
          </p>
          <p className="text-xs sm:text-sm lg:text-base text-gray-500 mt-2 lg:mt-4 italic">
            Complete the form accurately and download it to submit to your desired job opportunities.
          </p>
        </div>

        {/* Components Section */}
        <div className="lg:w-1/2 flex flex-col sm:flex-row lg:flex-col gap-4 sm:gap-6 lg:gap-8 px-2 sm:px-0 lg:pl-8">
          <div className="w-full sm:w-1/2 lg:w-full">
            <JobApplicationButton onClick={() => setShowForm(true)} />
          </div>
          <div className="w-full sm:w-1/2 lg:w-full">
            <FormAnalytics />
          </div>
        </div>

        {/* Modal for Job Application Form */}
        {showForm && <JobApplicationFormShareable onClose={() => setShowForm(false)} />}
      </div>
    </div>
  );
};

export default ApplicationForm;